import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
import { authApi } from '../api/client';
import { tokenStorage } from '../utils/storage';

let hasListeners = false;

export const NotificationService = {
    async init(navigate) {
        if (!Capacitor.isNativePlatform()) return;

        // Check/request permission
        let permStatus = await PushNotifications.checkPermissions();
        if (permStatus.receive === 'prompt') {
            permStatus = await PushNotifications.requestPermissions();
        }
        if (permStatus.receive !== 'granted') {
            console.warn('Push notification permission denied');
            return;
        }

        // Generate or get persistent device UUID
        let deviceId = await tokenStorage.getItem('deviceId');
        if (!deviceId) {
            deviceId = window.crypto.randomUUID ? window.crypto.randomUUID() : 'dev-' + Math.random().toString(36).substring(2, 15);
            await tokenStorage.setItem('deviceId', deviceId);
        }

        // Register with FCM
        await PushNotifications.register();

        if (hasListeners) return;
        hasListeners = true;

        // Listeners
        PushNotifications.addListener('registration', async (token) => {
            console.log('FCM Token registered:', token.value);
            try {
                const storedUser = await tokenStorage.getItem('user');
                if (storedUser) {
                    const user = JSON.parse(storedUser);
                    const userId = user?.userId || user?.id;
                    if (userId) {
                        let devId = await tokenStorage.getItem('deviceId');
                        if (!devId) {
                            devId = window.crypto.randomUUID ? window.crypto.randomUUID() : 'dev-' + Math.random().toString(36).substring(2, 15);
                            await tokenStorage.setItem('deviceId', devId);
                        }
                        await authApi.registerDevice({
                            deviceId: devId,
                            deviceName: 'Android Device',
                            platform: 'Android',
                            fcmToken: token.value,
                            appVersion: '1.0.0'
                        });
                        console.log('Successfully registered device token with backend');
                    }
                }
            } catch (err) {
                console.error('Failed to register device token with backend:', err);
            }
        });

        PushNotifications.addListener('registrationError', (err) => {
            console.error('FCM Registration Error:', err);
        });

        PushNotifications.addListener('pushNotificationReceived', (notification) => {
            console.log('Push received in foreground:', notification);
        });

        PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
            console.log('Push action performed:', action);
            const data = action.notification.data;
            if (data) {
                const type = data.type || data.NotificationType;
                const refId = data.referenceId || data.ReferenceId;

                if (type && refId) {
                    if (type.toLowerCase() === 'chat') {
                        navigate(`/chats/${refId}`);
                    } else if (type.toLowerCase() === 'order') {
                        navigate(`/orders/${refId}`);
                    } else if (type.toLowerCase() === 'ledger') {
                        navigate(`/dashboard/ledger?userId=${refId}`);
                    }
                }
            }
        });
    },

    async registerDeviceToken() {
        if (!Capacitor.isNativePlatform()) return;
        try {
            await PushNotifications.register();
        } catch (err) {
            console.error('Failed to register device token:', err);
        }
    },

    async unregister() {
        if (!Capacitor.isNativePlatform()) return;
        try {
            const deviceId = await tokenStorage.getItem('deviceId');
            if (deviceId) {
                await authApi.unregisterDevice({ deviceId });
                console.log('Successfully unregistered device token on backend');
            }
        } catch (e) {
            console.error('Failed to unregister device:', e);
        }
    }
};
